export function isInsideIframe() {
  if (typeof window === 'undefined') return false
  return window.self !== window.top
}
